<div class="ticker-filter-container">
  <label class="filter-label">Tickers</label>
  <div class="ticker-filter display-flex">
    <button
      nz-popover
      [(nzPopoverVisible)]="visible"
      (nzPopoverVisibleChange)="popOverChange()"
      nzPopoverTrigger="null"
      [nzPopoverContent]="contentTemplate"
      class="ticker-click-area"
      nzPopoverPlacement="bottomLeft"
      [nzPopoverOverlayClassName]="'ticker-filter-popover'"
      (click)="handleTickerDropdownFilterClick()"
    >
      <div class="popover-text">Select tickers</div>
      <va-icon
        size="small"
        [name]="visible ? 'chevron-up' : 'chevron-down'"
        class="select-ticker-arrow-icon"
      ></va-icon>
    </button>
    <button nz-button class="ticker-filter__edit-btn" (click)="editTickers()">
      Edit
    </button>
  </div>
</div>

<ng-template #contentTemplate>
  <div class="popover-container">
    <nz-radio-group [(ngModel)]="selectedTickerRadio">
      <div class="top-ten-radio">
        <label nz-radio nzValue="top_ten">Top 10 tickers</label>
        <va-icon
          isFontAwesome="true"
          [name]="faInfoCircle"
          class="top-ten-icon"
          nz-popover
          [nzPopoverContent]="topTenToolTipTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
        ></va-icon>
      </div>
      <div class="custom-radio">
        <label nz-radio nzValue="custom">Custom tickers</label>
        <va-icon
          isFontAwesome="true"
          [name]="faInfoCircle"
          class="custom-icon"
          nz-popover
          [nzPopoverContent]="customToolTipTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
        ></va-icon>
      </div>
    </nz-radio-group>

    <div class="transfer-container">
      <nz-transfer
        class="transfer-box"
        [nzDataSource]="list"
        [nzDisabled]="selectedTickerRadio === 'top_ten'"
        [nzListStyle]="{ 'width.px': 250, 'height.px': 325 }"
        [nzTitles]="transferTitles"
        nzSearchPlaceholder="Search Companies"
        [nzShowSelectAll]="false"
        nzShowSearch
        [nzFilterOption]="filterOption"
        (nzSearchChange)="search($event)"
        (nzSelectChange)="select($event)"
        (nzChange)="onTransferClick()"
      ></nz-transfer>
    </div>

    <div class="include-average-cb">
      <div *ngIf="selectedChartType !== chartType.comparison.id">
        <label nz-checkbox [(ngModel)]="includeAverage">Include Average</label>
        <va-icon
          isFontAwesome="true"
          [name]="faInfoCircle"
          class="average-icon"
          nz-popover
          [nzPopoverContent]="includeAverageToolTipTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
        ></va-icon>
      </div>
    </div>

    <div class="popover-footer">
      <div class="action-button-container">
        <button nz-button class="clear-btn" (click)="setupTickerSelectionBox()">
          Reset
        </button>
        <button
          nz-button
          [disabled]="
            !selectedTickerRadio ||
            (selectedTickerRadio === 'custom' &&
              (selectedCustomTickerCount === 0 ||
                selectedCustomTickerCount > 10))
          "
          class="apply-btn"
          (click)="handleApplyClick()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #topTenToolTipTemplate>
  <div class="tooltip-content">
    Show the top 10 tickers of the first estimated period within your selected
    period range for each line item from each trend table. You can change your
    period range to view different periods.
  </div>
</ng-template>

<ng-template #customToolTipTemplate>
  <div class="tooltip-content">
    Show up to 10 companies of my choice of the first estimated period within
    your selected period range for each line item from each trend table. You can
    change your period range to view different periods.
  </div>
</ng-template>

<ng-template #includeAverageToolTipTemplate>
  <div class="tooltip-content">
    Average of all companies in the comparative analysis peer group.
  </div>
</ng-template>
